import Table from "../../../components/Table/Table";
import { PaginationContainer, Header } from "../HomeStyled";
import Pagination from "../../../components/Pagination/Pagination";
import {
  fileNameColumn,
  assignedOnColumn,
  notesColumn,
  renderText,
  renderStatus,
} from "../../../utils/columns";
import PropTypes from "prop-types";
import { commonProps, paginationShape, signatureItemShape } from "../Proptypes/Proptypes";
import MatterLoader from "../../../components/Loader/MatterLoader";

const MySignature = ({
  mySignatureList,
  currentPage = 1,
  handlePageChange,
  onSort,
  getRowProps,
  filterState,
  handleChangePageSize,
  isLoading = false,
  isInitialLoad = false,
}) => {
  const { needsMySignature } = filterState;

  const search = "search logic has to be added here";
  const columns = [
    fileNameColumn(search, onSort),
    assignedOnColumn,
    {
      title: <Header>ASSIGNED BY</Header>,
      dataIndex: "assigned_by",
      key: "assigned_by",
      render: renderText,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      render: (text) => renderStatus("ESign", text),
    },
    notesColumn(search),
  ];
  return (
    <div style={{ position: 'relative', minHeight: '400px' }}>
      {isLoading && !isInitialLoad && (
        <MatterLoader message="Loading..." offsetTop={0} absolute={true} />
      )}
      {(!isLoading || isInitialLoad) && (
        <>
          <Table
            columns={columns}
            data={mySignatureList?.results || []}
            onRow={getRowProps}
            emptyMessage={"No records found"}
          />
          {mySignatureList?.results?.length > 0 && (
            <PaginationContainer>
              <Pagination
                total={mySignatureList?.pagination?.count}
                current={currentPage}
                pageSize={needsMySignature?.page_size}
                onChange={(page) =>
                  handlePageChange({ label: "page", value: page })
                }
                adjustable={false}
                onPageSizeChange={handleChangePageSize}
              />
            </PaginationContainer>
          )}
        </>
      )}
    </div>
  );
};

MySignature.propTypes = {
  mySignatureList: PropTypes.shape({
    results: PropTypes.arrayOf(signatureItemShape),
    pagination: paginationShape,
  }),
  ...commonProps,
  currentPage: PropTypes.number,
};

MySignature.defaultProps = {
  currentPage: 1,
};

export default MySignature;
